<template>
  <nav class="nav" :class="{ 'nav--inverse': handleProp(inverse) }">
    <div class="nav-body">
      <router-link class="logo" to="/">
        <img src="@/assets/logos/remax-colour.svg" alt="Remax Malta" v-if="handleProp(inverse)">
        <img src="@/assets/logos/remax-white.svg" alt="Remax Malta" v-else>
      </router-link>

      <a class="nav-icon nav-icon--back" @click="$router.back()" v-if="handleProp(showBack)">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M16.975 6.797a2 2 0 112.828 2.829L7.43 21.999 45 22a2 2 0 110 4H7.826L19.8 37.974a2 2 0 01.117 2.701l-.117.127a2 2 0 01-2.828 0L1.529 25.362a1.992 1.992 0 01-.725-1.323 1.997 1.997 0 01.746-1.819z"/></svg>
      </a>

      <router-link class="nav-icon nav-icon--filter" to="/wizard" v-if="handleProp(showFilter)">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M18.963 25.902L4.355 5.903C3.473 4.697 4.335 3 5.829 3h36.52c1.49 0 2.353 1.69 1.478 2.897L29.655 25.462v13.352c0 .632-.328 1.22-.865 1.552l-7.04 4.358c-1.217.753-2.787-.122-2.787-1.553v-17.27zM9.424 6.652l12.84 17.577c.228.312.35.69.35 1.077v14.588l3.389-2.098V24.87c0-.385.121-.76.347-1.071L38.771 6.652H9.424z"/></svg>
      </router-link>

      <router-link class="nav-icon nav-icon--favourites" to="/user/favourites" v-if="handleProp(showFavourites)">
        <span class="count">{{ likedPropertiesCount }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M34.202 4.185c-3.94 0-7.633 1.692-10.202 4.555a13.709 13.709 0 00-10.202-4.555C6.242 4.185.095 10.333.095 17.89c0 14.656 21.995 26.562 22.93 27.06a2.07 2.07 0 001.95 0c.935-.5 22.93-12.404 22.93-27.06 0-7.556-6.147-13.704-13.703-13.704zm-.566 29.79c-3.9 3.302-7.855 5.737-9.636 6.773-1.781-1.036-5.736-3.47-9.636-6.774-4.622-3.913-10.13-9.88-10.13-16.085 0-5.275 4.29-9.566 9.564-9.566a9.573 9.573 0 018.389 4.967 2.07 2.07 0 003.626 0 9.572 9.572 0 018.389-4.967c5.274 0 9.565 4.291 9.565 9.566 0 6.205-5.51 12.172-10.13 16.085z"/></svg>
      </router-link>

      <router-link class="nav-icon nav-icon--logout" to="/account/logout" v-if="handleProp(showLogout) && user.authenticated">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><g fill="#FFF" fill-rule="evenodd"><path d="M38.914 14.808l7.778 7.778a2 2 0 01.102 2.719l-.102.11-7.778 7.777a2 2 0 01-2.828-2.828L40.449 26H25a2 2 0 110-4h15.449l-4.363-4.364a2 2 0 012.828-2.828z"/><path fill-rule="nonzero" d="M27 41H4V7h23v8a2 2 0 104 0V5a2 2 0 00-2-2H2a2 2 0 00-2 2v38a2 2 0 002 2h27a2 2 0 002-2V33a2 2 0 10-4 0v8z"/></g></svg>
      </router-link>
    </div>
  </nav>
</template>

<style scoped lang="scss">
  .nav {
    max-width: 1260px;
    margin: 0 auto;
    padding: 10px;

    @include min-sm {
      padding: 20px 10px;
    }

    &--inverse {
      .nav-icon .icon {
        fill: rgb(var(--gray-10));
      }
    }
  }

  .nav-body {
    display: flex;
    align-items: center;

    .logo {
      margin: 0 auto;
      padding: 10px;
      order: 1;

      @include min-sm {
        margin: 0 auto 0 0;
        order: 0;
      }

      img {
        width: 130px;

        @include min-sm {
          width: auto;
        }
      }
    }

    .nav-icon {
      position: relative;
      padding: 10px;
      fill: rgb(var(--white));
      cursor: pointer;

      &--back {
        order: 0;
      }

      &--logout {
        order: 2;
      }

      &--favourites {
        order: 2;

        @include min-sm {
          order: 1;
        }

        .count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          
          position: absolute;
          right: 2px;
          bottom: 13px;
          width: 17px;
          height: 17px;
          padding: 0.2em;
          background-color: rgb(var(--red-0));
          border-radius: 50%;

          color: rgb(var(--white));
          font-size: 0.9rem;
          font-weight: var(--weight-bold);

          @include min-sm {
            right: 5px;
            bottom: 15px;
            width: 20px;
            height: 20px;
            padding: 0.3em;
            font-size: 1rem;
          }
        }
      }

      .icon {
        width: 2.2rem;
        height: 2.2rem;

        @include min-sm {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }
</style>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'Navigation',

    props: {
      inverse: {
        type: [Boolean, Object],
        default: false
      },

      showFavourites: {
        type: [Boolean, Object],
        default: true
      },

      showLogout: {
        type: [Boolean, Object],
        default: false
      },

      showFilter: {
        type: [Boolean, Object],
        default: false
      },

      showBack: {
        type: [Boolean, Object],
        default: false
      }
    },

    computed: {
      ...mapState([
        'user'
      ]),

      ...mapGetters([
        'likedPropertiesCount'
      ])
    },

    methods: {
      handleProp (prop) {
        if (typeof prop === 'boolean') return prop;
        
        const isDesktop = window.matchMedia('(min-width: 540px)').matches;

        return isDesktop ? prop.desktop : prop.mobile;
      }
    }
  };
</script>